import { render, staticRenderFns } from "./01-Start.vue?vue&type=template&id=79f61cba&scoped=true&"
import script from "./01-Start.vue?vue&type=script&lang=js&"
export * from "./01-Start.vue?vue&type=script&lang=js&"
import style0 from "./01-Start.vue?vue&type=style&index=0&id=79f61cba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79f61cba",
  null
  
)

export default component.exports